class ChargecodeTableController {

  delete(id) {
    this.onDelete({id: id});
  }
}

export default ChargecodeTableController;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-create/components/chargecode-table/chargecode-table.controller.js